import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gridTemplateRows: "1fr",
    gap: 12,
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gridTemplateRows: "1fr",
    },
  },
  field: {
    gridRow: "span 1",
    [theme.breakpoints.up("md")]: {
      gridColumn: "span 1",
    },
  },
}));
